<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="600px">
    <v-card>
      <v-toolbar dense class="elevation-2">
        <v-spacer></v-spacer>
        <v-toolbar-title>
          Create New User
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close()"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-select
              filled
              :items="userType_options"
              v-model="user.role"
              label="Select User Type"
              item-value="value"
              item-text="text"
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="user.role !== ''">
          <v-col md="6" xs="12" v-if="needCompany">
            <label>Company</label>
            <v-select
              solo
              :items="company_options"
              v-model="user.companyID"
              label="Assign User to a Company"
              item-value="id"
              item-text="name"
            ></v-select>
          </v-col>
          <v-col md="6" sm="12" v-bind:class="{ 'has-error': $v.user.firstName.$error }">
            <label>First Name</label>
            <v-text-field
              solo
              placeholder="Enter user first name"
              v-model="user.firstName"
              @input="$v.user.firstName.$touch()"
            ></v-text-field>
            <span class="help-block" v-if="!$v.user.firstName.required && $v.user.firstName.$error">First name is required</span>
          </v-col>
          <v-col md="6" sm="12" v-bind:class="{ 'has-error': $v.user.lastName.$error }">
            <label>Last Name</label>
            <v-text-field
              solo
              placeholder="Enter user last name"
              v-model="user.lastName"
              @input="$v.user.lastName.$touch()"
            ></v-text-field>
            <span
              class="help-block"
              v-if="!$v.user.lastName.required && $v.user.lastName.$error"
            >
              Last name is required
            </span>
          </v-col>
          <v-col md="6" xs="12" v-bind:class="{ 'has-error': $v.user.email.$error }">
            <label>Email</label>
            <v-text-field
              solo
              placeholder="Enter email"
              v-model="user.email"
              @input="$v.user.email.$touch()"
              @keydown.space.prevent 
              @paste="preventPasteSpaces"
            ></v-text-field>
            <span
              class="help-block"
              v-if="!$v.user.email.required && $v.user.email.$error"
            >
              Email is required
            </span>
          </v-col>
          <v-col md="6" xs="12" v-bind:class="{ 'has-error': $v.user.password.$error }">
            <label>Password</label>
            <v-text-field
              solo
              type="password"
              placeholder="Enter password"
              v-model="user.password"
              @blur="$v.user.password.$touch()"
            ></v-text-field>
            <span
              class="help-block"
              v-if="!$v.user.password.required && $v.user.password.$error"
            >
              Password is required
            </span>
          </v-col>
          <v-col md="6" xs="12" v-if="isInf">
            <v-select
              filled
              :items="platforms"
              v-model="platform"
              label="Select User Type"
              item-value="value"
              item-text="text"
            ></v-select>
          </v-col>
          <v-col md="6" xs="12" v-if="user.role === userRoles.ACCOUNT_MANAGER">
            <label>Account Admins</label>
            <v-select
              solo
              multiple
              :items="accountAdmins"
              v-model="user.accountAdmins"
              label="Select Admin Users"
              item-value="id"
              item-text="name"
            ></v-select>
          </v-col>
          <!-- Start Facebook -->
          <v-col md="6" xs="12" v-if="isFacebookPlatform">
            <v-text-field
              solo
              placeholder="Enter Facebook Handle"
              v-model="facebook.fbHandle"
            ></v-text-field>
          </v-col>
          <v-col md="6" xs="12" v-if="isFacebookPlatform">
            <v-text-field
              type="number"
              solo
              placeholder="Enter Total Followers"
              v-model="facebook.totalFollowers"
            ></v-text-field>
          </v-col>
          <v-col md="6" xs="12" v-if="isFacebookPlatform">
            <v-text-field
              type="number"
              solo
              placeholder="Enter Total Following"
              v-model="facebook.totalFollowing"
            ></v-text-field>
          </v-col>
          <!-- End Facebook -->
          <!-- Start XHS -->
          <v-col md="6" xs="12" v-if="isXHSPlatform">
            <v-text-field
              solo
              placeholder="Enter XHS Fullname"
              v-model="xhs.xhsFullname"
            ></v-text-field>
          </v-col>
          <v-col md="6" xs="12" v-if="isXHSPlatform">
            <v-text-field
              solo
              placeholder="Enter XHS Handle"
              v-model="xhs.xhsHandle"
            ></v-text-field>
          </v-col>
          <v-col md="6" xs="12" v-if="isXHSPlatform">
            <v-text-field
              solo
              placeholder="Enter XHS ID"
              v-model="xhs.xhsID"
            ></v-text-field>
          </v-col>
          <v-col md="6" xs="12" v-if="isXHSPlatform">
            <v-text-field
              type="number"
              solo
              placeholder="Enter Total Followers"
              v-model="xhs.totalFollowers"
            ></v-text-field>
          </v-col>
          <v-col md="6" xs="12" v-if="isXHSPlatform">
            <v-text-field
              type="number"
              solo
              placeholder="Enter Total Following"
              v-model="xhs.totalFollowing"
            ></v-text-field>
          </v-col>
          <v-col md="6" xs="12" v-if="isXHSPlatform">
            <v-text-field
              type="number"
              solo
              placeholder="Enter Total Likes/Favourites"
              v-model="xhs.totalLikesFavourites"
            ></v-text-field>
          </v-col>
          <!-- End XHS -->
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close()">Close</v-btn>
        <v-btn class="secondary" @click="createUser()">Save changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import companyAPIs from '../Company/companyAPIs'
import userAPIs from './userAPIs'
import config from '@/config'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CreateUserModal',
  props: {
    value: Boolean
  },
  data () {
    return {
      userType_options: [],
      company_options: [],
      accountAdmins: [],
      user: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        role: '',
        companyID: '',
        accountAdmins: []
      },
      xhs: {
        xhsFullname: '',
        xhsHandle: '',
        xhsID: '',
        totalFollowers: '',
        totalFollowing: '',
        totalLikesFavourites: ''
      },
      facebook: {
        fbHandle: '',
        fbID: '',
        totalFollowers: '',
        totalFollowing: ''
      },
      platform: '',
      platforms: ['Others', 'Facebook', 'XHS'],
      userRoles: config.userRoles
    }
  },
  validations: {
    user: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required
      },
      password: {
        required
      },
      companyID: {
        required
      }
    }
  },
  computed: {
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    needCompany: function () {
      // If a new company admin / ad strategist is created naturally (but not by system admin),
      // then do not display the company dropdown list
      if (
          this.currentUserRole === config.userRoles.COMPANY_ADMIN_HIGH ||
          this.currentUserRole === config.userRoles.COMPANY_ADMIN_LOW
        ) {
        return false
      }

      // If system admin create new company users then we need to show the company list
      const newUserRole = Number(this.user.role)
      if (
          newUserRole === config.userRoles.COMPANY_ADMIN_HIGH ||
          newUserRole === config.userRoles.COMPANY_ADMIN_LOW ||
          newUserRole === config.userRoles.AD_STRATEGIST ||
          newUserRole === config.userRoles.ACCOUNT_MANAGER ||
          newUserRole === config.userRoles.FINANCE ||
          newUserRole === config.userRoles.MARKETING
        ) {
        return true
      }
      return false
    },
    isInf() {
      return this.user.role === config.userRoles.INFLUENCER
    },
    isXHSPlatform() {
      return this.platform === 'XHS'
    },
    isFacebookPlatform() {
      return this.platform === 'Facebook'
    }
  },
  methods: {
    close: function () {
      this.$emit('input')
    },
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    },
    createUser: function () {
      if (this.user.email) {
        this.user.email = this.user.email.trim()
      }
      let user = Object.assign({}, this.user)

      if (this.needCompany === false) {
        // If user is created by company admin then we do not need to set this explicitly but let server handle the assignment
        delete user.companyID
      }
      // if not XHS, del XHS objects
      if (this.platform === 'XHS') {
        user.xhs = Object.assign({}, this.xhs)
      }
      // if not Facebook, set facebook objects
      if (this.platform === 'Facebook') {
        this.facebook.firstName = user.firstName
        this.facebook.lastName = user.lastName
        this.facebook.fbFullname = `${this.facebook.firstName} ${this.facebook.lastName}`
        user.facebook = Object.assign({}, this.facebook)
      }

      // Add user
      userAPIs.createUser(user)
        .then(response => {
          // Return the newly added data to parent component
          this.$emit('createUser', response)
          this.close()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
          this.$swal({
            title: 'Error',
            text: 'Error Creating User!',
            type: 'error'
          });
          this.close()
        })
    },
    clearData: function () {
      this.user = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        role: ''
      }
    },
    async getAdminUsers() {
      let adminUsers = await userAPIs.getAllUsersByRole(config.userRoles.COMPANY_ADMIN_HIGH)
      if (adminUsers.users) {
        adminUsers = adminUsers.users
        adminUsers = adminUsers.map(user => {
          return {
            id: user.id,
            name: `${user.firstName} ${user.lastName}`
          }
        })
        return adminUsers
      }
      return []
    }
  },
  async mounted () {
    const createUserList = config['userPermissions']['user']['create'][this.currentUserRole]

    // Update userType select options
    var userTypeTemp = []
    Object.keys(createUserList).forEach(function(element) {
      const value = createUserList[element]
      userTypeTemp.push({
        value: value,
        text: config['userRolesDetails'][value]['display']
      })
    })
    this.userType_options = userTypeTemp
    this.userType_options = this.userType_options.filter(u => u.text !== 'Influencer')

    // Update company select options
    if (
      this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    ) {
      companyAPIs.getAllCompanies(false)
        .then(response => {
          this.company_options = response.data
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    }
    this.accountAdmins = await this.getAdminUsers()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CreateUserModal.vue?36f8278a